<template>
  <div class="navi-group">
    <div class="top">
      <div class="tit" @click="utils.movePage('/safetyLeadership')">
        {{t('message.safetyLeadership')}}
      </div>
      <div class="navi-home-btn">
        <v-btn @click="utils.movePage('/safetyLeadership')"></v-btn>
      </div>
      <v-btn
        icon="mdi-close"
        variant="text"
        @click.stop="onClickMobileMenu"
        v-if="utils.isMobile()"
      ></v-btn>
      <div class="navi-info-btn">
        <v-menu
          transition="slide-y-transition"
          location="right center"
          v-if="showMenu"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
            >
            </v-btn>
          </template>
          <v-list class="set-menu-list">
            <v-list-item
              v-for="(item, i) in naviSet"
              :key="i"
            >
              <v-list-item-title>
                <button type="button" @click="utils.movePage(item.link)">
                  {{ item.title }}
                </button>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-title>{{t('message.favorites')}}</v-expansion-panel-title>
        <v-expansion-panel-text>
          <ul>
            <li v-for="item in bookmarkItems">
              <div class="chk-favorites">
                <v-checkbox
                  :model-value="true"
                  @click="onChangeCheck(item.idx, $event)"
                ></v-checkbox>
              </div>
              <div class="btn-navi-txt">
                <v-btn @click="utils.movePage('/safetyLeadershipRun/1/'+item.idx)">{{ item.leadershipTitle }}</v-btn>
              </div>
              <div class="navi-more-btn">
                <v-menu
                  transition="slide-y-transition"
                  location="right center"
                  v-if="showBbs"
                >
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-bind="props"
                    >
                    </v-btn>
                  </template>
                  <v-list class="set-menu-list">
                    <v-list-item
                      v-for="(menu, i) in naviList"
                      :key="i"
                    >
                      <v-list-item-title>
                        <button type="button" @click="onClickMenu(menu.menu, item.idx)">
                          {{ menu.title }}
                        </button>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </li>
          </ul>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>{{t('message.myTask')}}</v-expansion-panel-title>
        <v-expansion-panel-text>
          <ul>
            <li v-for="item in leadershipItems">
              <div class="chk-favorites">
                <v-checkbox
                  :model-value="item.bookmark"
                  @click="onChangeCheck(item.idx, $event)"
                ></v-checkbox>
              </div>
              <div class="btn-navi-txt">
                <v-btn @click="utils.movePage('/safetyLeadershipRun/1/'+item.idx)">{{ item.leadershipTitle }}</v-btn>
              </div>
              <div class="navi-more-btn">
                <v-menu
                  transition="slide-y-transition"
                  location="right center"
                  v-if="showBbs"
                >
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-bind="props"
                    >
                    </v-btn>
                  </template>
                  <v-list class="set-menu-list">
                    <v-list-item
                      v-for="(menu, i) in naviList"
                      :key="i"
                    >
                      <v-list-item-title>
                        <button type="button" @click="onClickMenu(menu.menu, item.idx)">
                          {{ menu.title }}
                        </button>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </li>
          </ul>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>{{userInfo.roles=='USER'?t('message.otherObserveTask'):t('message.orgCreatedTask')}}</v-expansion-panel-title>
        <v-expansion-panel-text>
          <ul>
            <li v-for="item in otherTargetItems">
              <div class="chk-favorites">
                <v-checkbox
                  :model-value="item.bookmark"
                  @click="onChangeCheck(item.idx, $event)"
                ></v-checkbox>
              </div>
              <div class="btn-navi-txt">
                <v-btn @click="utils.movePage('/safetyLeadershipRun/1/'+item.idx)">{{ item.leadershipTitle }}</v-btn>
              </div>
              <div class="navi-more-btn">
                <v-menu
                  transition="slide-y-transition"
                  location="right center"
                  v-if="showBbs"
                >
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-bind="props"
                    >
                    </v-btn>
                  </template>
                  <v-list class="set-menu-list">
                    <v-list-item
                      v-for="(menu, i) in naviList"
                      :key="i"
                    >
                      <v-list-item-title>
                        <button type="button" @click="onClickMenu(menu.menu, item.idx)">
                          {{ menu.title }}
                        </button>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </li>
          </ul>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <c-dialog v-model="dialogAllDeleteModel"
            v-bind="dialogAllDeleteBind"
            @close="dialogAllDeleteModel=false"
            @confirm="confirmDelete"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script lang="ts" setup>
import {onMounted, ref, watch} from 'vue'
import utils from "@/common/Utils"
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import LeadershipService from "@/services/leadership.service";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const emit = defineEmits(['closeMobileMenu'])

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const snackbar = ref(false)
const snackText = ref('')
const naviSet = ref([
  { title: t('message.behaviorManagement'), link:'/safetyLeadershipAMList'},
  { title: t('message.safetyManagementSetting'), link:'/safetyLeadershipManagement'},
])
const naviList = ref([
  { title: t('message.edit'), menu:'update'},
  //{ title: t('message.disableEnable'), menu:'active'},
  { title: t('message.delete'), menu:'delete' },
])
const panel = ref([0, 1, 2])
const showMenu = ref(false)
const showBbs = ref(false)
const bookmarkItems = ref([]) //북마크
const leadershipItems = ref([]) //리더십 과제
const otherTargetItems = ref([]) //타인관찰 과제
const dialogAllDeleteModel = ref(false)
let selectedIdx = 0
const userInfo = ref(JSON.parse(localStorage.getItem('user')))

//ui
const dialogAllDeleteBind = {
  dialogTit: t('message.deleteAction'),
  dialogText: t('message.deleteConfirmTitleDesc'),
  btn1Text: t('message.delete'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}

//watch
watch(storeRef.user, async (newData, oldData) => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (storeRef.user.value === null) {
      storeRef.user.value = user
    }

    if((user.roles == 'ADMIN1' || user.roles == 'ADMIN2' || user.roles == 'ADMIN3') && !utils.isMobile()){
      showMenu.value = true
      showBbs.value = true
    }
  },
  {
    deep: true,
    immediate:true
  }
)

//hook
onUpdated (() => {
  const user = JSON.parse(localStorage.getItem('user'))
  if(storeRef.user.value === null){
    storeRef.user.value = user
  }
})

onMounted(() => {
  loadData('all')
})

// function
const loadData = (type)=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let user = JSON.parse(localStorage.getItem('user'))
  let params = {
    companyIdx:companyIdx,
    memberIdx:user.memberIdx,
    bookmarkType:'2'
  }

  LeadershipService.getBookmarkList(params).then(
    (response) => {
      bookmarkItems.value = response.result
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )

  if(type == 'all'){
    LeadershipService.getLeadershipNaviList(params).then(
      (response) => {
        leadershipItems.value = response.result.leadershipList
        otherTargetItems.value = response.result.otherTargetList
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

//function
const onClickMenu = (menu, idx)=>{
  selectedIdx = idx
  if(menu == 'update') {
    utils.movePage('/safetyLeadershipManagementDetail/' + idx)
  }
  else if(menu == 'show'){
    updateColumn('showYn', idx)
  }
  else if(menu == 'active'){
    updateColumn('activeYn', idx)
  }
  else if(menu == 'delete'){
    dialogAllDeleteModel.value=true
  }
}

const onChangeCheck = (item, e)=>{
  let user = JSON.parse(localStorage.getItem('user'))
  let params = {
    bookmarkType:'2',
    parentIdx:item,
    memberIdx:user.memberIdx,
  }

  if(e.target.checked){
    LeadershipService.insertBookmark(params).then(
      (response) => {
        loadData('bookmark')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
  else{
    LeadershipService.deleteBookmark(params).then(
      (response) => {
        loadData('bookmark')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

const updateColumn = (columnKey, idx)=>{
  if(import.meta.env.MODE == 'development') {
    snackText.value = 'success'
    snackbar.value = true
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    if(!companyIdx)
      utils.movePage('/login')

    let params = {
      companyIdx:companyIdx,
      idx: selectedIdx,
      updateColumnKey: columnKey,
      updateColumnValue: 'toggle'
    }

    LeadershipService.updateLeadershipColumn(params).then(
      (response) => {
        if(response.success) {
          if(params.updateColumnKey == 'showYn' && response.result.showYn == 'Y')
            snackText.value = t('message.exposureResumed')
          else if(params.updateColumnKey == 'showYn' && response.result.showYn == 'N')
            snackText.value = t('message.exposureStopped')
          else if(params.updateColumnKey == 'activeYn' && response.result.activeYn == 'Y')
            snackText.value = t('message.operationResumed')
          else if(params.updateColumnKey == 'activeYn' && response.result.activeYn == 'N')
            snackText.value = t('message.operationStopped')
          snackbar.value = true
        }
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

const confirmDelete = ()=> {
  if(import.meta.env.MODE == 'development') {
    snackText.value = 'success'
    snackbar.value = true
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    let params = {
      companyIdx:companyIdx,
      idx: selectedIdx,
    }

    LeadershipService.deleteLeadership(params).then(
      (response) => {
        if(response.success) {
          bookmarkItems.value = []
          leadershipItems.value = []
          loadData('all')
        }
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

const onClickMobileMenu = ()=>{
  emit('closeMobileMenu', '')
}

defineExpose({
  loadData,
})
</script>

<style lang="scss">

.navi-group{
  position:absolute;
  top:0;
  left:0;
  padding:2rem 3rem 3rem;
  width:26rem;
  border:1px solid var(--color-line);
  border-radius:2rem;
  .top{
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding-bottom:1.2rem;
    .tit{
      display:none;
      font-size:1.8rem;
      line-height:2.4rem;
      font-weight:700;
    }
    .navi-info-btn{
      margin-left:.7rem;
      .v-btn--size-default{
        --v-btn-height:2.4rem;
      }
      .v-btn{
        background:url("@/assets/img/ico-set.svg")center no-repeat;
        box-shadow:none;
        min-width:2.4rem;
        padding:0;
        border-radius:100%;
        & > *{border-radius:100%;width:2.4rem;height:2.4rem}
        @supports selector(:focus-visible) {
          .v-btn::after {
            border:0
          }
        }
      }
      .navi-home-btn{
        .v-btn--size-default{
          --v-btn-height:2.4rem;
        }
        .v-btn{
          background:url("@/assets/img/ico-home.svg")center no-repeat;
          box-shadow:none;
          min-width:2.4rem;
          padding:0;
          border-radius:100%;
          & > *{border-radius:100%;width:2.4rem;height:2.4rem}
          @supports selector(:focus-visible) {
            .v-btn::after {
              border:0
            }
          }
        }
      }
    }
  }

  .v-expansion-panel{
    border-radius:.6rem;
    border:1px solid var(--color-line);
    .v-expansion-panel__shadow{
      box-shadow:0 .4rem 2rem 0 rgba(0, 0, 0, 0.07);
    }
    .v-expansion-panel-title{
      font-size:1.5rem;
      font-weight:700;
      min-height:4.8rem;
      padding:1rem 1rem 1rem 1.5rem;
    }
    &.v-expansion-panel--active > .v-expansion-panel-title:not(.v-expansion-panel-title--static){
      min-height:4.8rem;
    }
    .v-expansion-panel-text__wrapper{
      padding:0;
    }
    .mdi-chevron-up::before{
      opacity:.4;
    }
    li{
      position:relative;
      display:flex;
      justify-content: space-between;
      align-items: center;
      padding:1.2rem .8rem;
      .chk-favorites{
        .v-input{
          display: flex;
          .v-selection-control__input{
            width:3rem;
            height:3rem;
          }
          .v-selection-control__wrapper{
            width:3rem;
            height:3rem;
          }
          .v-icon{
            width:2.4rem;
            height:2.4rem;
            &:before{
              content:'';
              width:2.4rem;
              height:2.4rem;
              background-position:center;
              background-repeat:no-repeat;
              background-size:2.4rem auto;
            }
            &.mdi-checkbox-blank-outline::before{
              background-image: url("/src/assets/img/star-off.png");
            }
            &.mdi-checkbox-marked::before{
              background-image: url("/src/assets/img/star-on.png");

            }
          }
        }
        .v-input--density-default{
          --v-input-control-height:2.4rem;
          --v-input-padding-top:0
        }
      }
      .btn-navi-txt{
        display:inline-block;
        flex:1;
        .v-btn--variant-elevated{
          box-shadow:none;
        }
        .v-btn{
          padding:0;
          font-size:1.5rem;
          line-height:3rem;
          color:var(--navi-box-txt);
          height:3rem;
          font-weight:700;
          border-radius:0;
          letter-spacing:0;
          .v-btn__content{
            display:block;
            width:100%;
            text-overflow:ellipsis;
            overflow:hidden;
          }
        }
      }
      .navi-more-btn{
        margin-left:.7rem;
        .v-btn--size-default{
          --v-btn-height:2.4rem;
        }
        .v-btn{
          background:url("@/assets/img/dots-vertical.svg")center no-repeat;
          opacity:.6;
          box-shadow:none;
          min-width:2.4rem;
          padding:0;
          border-radius:100%;
          & > *{border-radius:100%;width:2.4rem;height:2.4rem}
          @supports selector(:focus-visible) {
            .v-btn::after {
              border:0
            }
          }
        }
      }
    }
  }
  .v-expansion-panel + .v-expansion-panel{margin-top:2rem}
  .v-expansion-panels:not(.v-expansion-panels--variant-accordion) > :first-child:not(:last-child):not(.v-expansion-panel--active):not(.v-expansion-panel--before-active){
    border-bottom-left-radius: 0.6rem !important;
    border-bottom-right-radius: 0.6rem !important;
  }
  .v-expansion-panels:not(.v-expansion-panels--variant-accordion) > :last-child:not(:first-child):not(.v-expansion-panel--active):not(.v-expansion-panel--after-active){
    border-top-left-radius: 0.6rem  !important;
    border-top-right-radius: 0.6rem  !important;
  }
  .v-expansion-panel:not(:first-child)::after{
    display: none;
  }
}
@media (max-width: 853px){
  .navi-group{
    position:relative;
    padding:2rem 0 0;
    width:100%;
    border:0;
    .v-expansion-panel-title:hover > .v-expansion-panel-title__overlay{
      opacity:0;
    }
    .mdi-chevron-down::before{
      opacity:0.4;
    }
    .top{
      .tit{
        display:block;
      }
      .navi-home-btn{
        display:none;
      }
      .v-btn--icon.v-btn--density-default{
        width:4rem;
        height:4rem;
        margin-right:-.5rem;
      }
      .mdi-close::before{
        font-size:2rem;
      }
      .navi-info-btn{
        display:none;
      }
    }
  }
}
</style>
